import linkedin from "./images/linkedin.png";
import instagram from "./images/instagram.png";
import github from "./images/github.png";
import LeetCode from "./images/LeetCode.png";
import cc from "./images/cc.png";
import gmail from "./images/gmail.png";

const SocialLinks = [
  {
    logo: linkedin,
    href: "https://www.linkedin.com/in/dhara-poptani-758a49210",
    title: "Dhara Poptani",
  },
  {
    logo: github,
    href: "https://github.com/dharapoptani",
    title: "dharapoptani",
  },
  {
    logo: instagram,
    href: "https://www.instagram.com/poptanidhara",
    title: "poptanidhara",
  },
  {
    logo: gmail,
    href: "#",
    title: "poptanidhara71@gmail.com",
  },
  {
    logo: cc,
    href: "https://www.codechef.com/users/dhara168",
    title: "dhara168",
  },
  {
    logo: LeetCode,
    href: "https://leetcode.com/dhara861/",
    title: "dhara861",
  },
];
export default SocialLinks;
